import { urls } from "../constants";
import { Post } from "../fetch";
export async function impersonate(body) {
  return Post(`${urls.identity.impersonate.v1}`, body);
}